export default {"src":"/_next/static/media/close.915fc8dd.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};